import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../service/settings.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { defaultFields, defaultFieldsTypes, deepCopy, removeUndefinedValuesFromObject,isTime, makeid, fieldTypeTitles, elementTypesWorkTaskTemplate, newSectionWorkTaskTemplate } from 'na-lib';
import { TaskTemplateEditSectionDialogComponent } from '../worktask-template-edit-section-dialog/worktask-template-edit-section-dialog.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { WorkTaskTemplateDialogComponent } from '../work-task-template-dialog/work-task-template-dialog.component';
import { CommentsService } from '../../service/comments.service';
import { TaskTemplateFieldDialogComponent } from '../worktask-template-field-dialog/worktask-template-field-dialog.component';
import { WorkTaskTemplatesService } from '../../service/work-task-templates.service';
import { supportUrlStructure } from 'src/app/supportUrls';
import { DeleteConfirmationDialogComponent } from '../../delete-confirmation-dialog/delete-confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { WorkTaskTemplateAdvancedDialogComponent } from '../../worktask/work-task-template-advanced-dialog/work-task-template-advanced-dialog.component';
import { CancelChangesDialogComponent } from '../../cancel-changes-dialog/cancel-changes-dialog.component';
import { Subscription, Observable, takeUntil, Subject } from 'rxjs';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { deleteField } from '@angular/fire/firestore';
import { CanComponentDeactivate } from '../../can-deactivate/can-deactivate.guard';
import MarkdownIt from 'markdown-it';
import { UserGroupService } from '../../service/user-group.service';

@Component({
    selector: 'app-worktask-template-item',
    templateUrl: './worktask-template-item.component.html',
    styleUrls: ['./worktask-template-item.component.css'],
    standalone: false
})
export class TaskTemplateItemComponent implements CanComponentDeactivate{
  routerUrl:any
  idToShow:any
  taskTemplate:any
  titleTask:string
  taskTemplateGroupName:string
  userGroupNames:string[]
  oldData:any
  sections:any = []
  taskTemplateForm!:FormGroup
  taskTemplateGroups:any
  fieldTypes = defaultFieldsTypes
  tasktemplateUserRights_update:any
  fakeForm:any
  tasktemplateUserRights_delete:any
  phoneFullHeightView = false;
  changesToSave=false
  emptyList=false
  private routerSubscription: Subscription;
  private taskTemplateGroupsSubscription?: Subscription;
  changesCanceled = false
  allKeys:any = []
  allIds:any=[]
  userGroupList:any
  duplicateKeys = false
  addedFields:any = 0
  addedFieldsByType: { [key: string]: number } = {}
  fieldTypeTitles: { [key: string]: string } = fieldTypeTitles
  allContentTypesList:any
  missingContentType = false
  selectedContentType:string
  elementTypes:any = elementTypesWorkTaskTemplate
  private destroy$ = new Subject<void>();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private settingService: SettingsService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private commentService: CommentsService,
    private worktasktemplateService: WorkTaskTemplatesService,
    private translate:TranslateService,
    private usGroupsService: UserGroupService
    ){
    this.routerUrl=this.route.url
    this.idToShow=this.routerUrl.value[this.routerUrl.value.length-1].path

    this.route.params.subscribe( value => {
      this.idToShow = value?.['taskTemplateId']
    })
    
    this.translate.get([
      'taskTemplates.add_display',
      'taskTemplates.add_hidden',
      'taskTemplates.add_text',
      'taskTemplates.add_longText',
      'taskTemplates.add_number',
      'taskTemplates.add_decimal',
      'taskTemplates.add_currency',
      'taskTemplates.add_date',
      'taskTemplates.add_dateTime',
      'taskTemplates.add_time',
      'taskTemplates.add_switch',
      'taskTemplates.add_list',
      'taskTemplates.add_weight',
      'taskTemplates.add_tridy',
      'taskTemplates.add_barcode',
      'taskTemplates.add_signature',
      'taskTemplates.add_doc',
      'taskTemplates.add_nfc',
      'taskTemplates.add_showText',
      'taskTemplates.add_showImage'
    ]).subscribe(translations => {
      Object.keys(translations).forEach(key => {
        const fieldType = key.replace('taskTemplates.add_', '');
        this.fieldTypeTitles[fieldType] = translations[key];
      });
    });
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.changesToSave) {
      return this.openCancelChangesDialog();
    } else {
      return true; // Allow navigation if no changes
    }
  }

  private openCancelChangesDialog(): Observable<boolean> {
    const dialogRef = this.dialog.open(CancelChangesDialogComponent, {
      data: 'takTemplates'
    });

    return dialogRef.afterClosed();
  }

  async ngOnInit():Promise<void>{

    // Stop reload event if there are unsaved changes
    window.onbeforeunload = (event) => {
      if (this.changesToSave && !this.changesCanceled) {
        // Display a confirmation message
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      }
    };

    this.taskTemplateForm = this.fb.group({
      actions: [],
      groupTitle:[],
      contentType: [],
      formSections: [],
      id:[],
      sortIndex: [],
      title: [],
      tridySource: [],
      visibleInPass: [],
      predicates: [],
      titleKeys:[],
      incomingTridys:[],
      outgoingTridys:[],
      taskType:[],
      groupId:[],
      userGroupIds:[],
      showImages:[],
      showComment:[],
      hidden:[],
      gpsMandatory:[],
    })

    this.getContent()
    this.tasktemplateUserRights_update = this.settingService.modulesRolesRights$.value['workTaskTemplates']['U']
    this.tasktemplateUserRights_delete = this.settingService.modulesRolesRights$.value['workTaskTemplates']['D']

    this.settingService.modulesRolesRights$.subscribe( value => {
      this.tasktemplateUserRights_update = this.settingService.modulesRolesRights$.value['workTaskTemplates']['U']
      this.tasktemplateUserRights_delete = this.settingService.modulesRolesRights$.value['workTaskTemplates']['D']
    })
    if(!this.tasktemplateUserRights_delete){
      if(document.getElementById("btn-delete"))
      document.getElementById("btn-delete").style.color='#e0e0e0'
    }

    if(!this.tasktemplateUserRights_update){
      if(document.getElementById("btn-cancel"))
      document.getElementById("btn-cancel").style.color='#e0e0e0'
      if(document.getElementById("btn-save"))
      document.getElementById("btn-save").style.backgroundColor='#e0e0e0'
    }

    if(this.settingService.settingsContentTypesWithId.length==0){
      try{
        this.commentService.progressSpin.emit(true)
        this.settingService.observeContextsContentTypesFirestoreWithId(this.settingService.contextId$).subscribe( value => {
          this.allContentTypesList = value
          this.commentService.progressSpin.emit(false)
        })
      }catch(error){
        this.commentService.progressSpin.emit(false)
        const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
        this.commentService.addSnackBar.emit(message)
      }
    }else{
      this.allContentTypesList = this.settingService.settingsContentTypesWithId
    }

    this.getTasksTemplatesGroups()

    this.taskTemplateForm.get('formSections')?.valueChanges.subscribe(value => {
      this.checkDuplicatesKeys()
    })

    this.taskTemplateForm.get('contentType')?.valueChanges.subscribe(value => {
      if(value)
        this.missingContentType = false
      this.selectedContentType = value
      this.checkDuplicatesKeys()
    })

    this.getUserGroups()

    this.settingService.contextIdChange$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getTasksTemplatesGroups()
    })
  }

  drop(event: CdkDragDrop<string[]>, index:number) {
    const previousIndex = parseInt(event.previousContainer.id.slice(-1))
    if(this.tasktemplateUserRights_update){
      if(event.previousContainer.id === event.container.id)
      moveItemInArray(this.sections[index].fields, event.previousIndex, event.currentIndex);
      else
      transferArrayItem(this.sections[previousIndex].fields,this.sections[index].fields, event.previousIndex, event.currentIndex)
      this.taskTemplateForm.patchValue({formSections: this.sections})
    }
  }

  dropPanel(event: CdkDragDrop<string[]>) {
    if(this.tasktemplateUserRights_update){
      moveItemInArray(this.sections, event.previousIndex, event.currentIndex);
      this.taskTemplateForm.patchValue({ formSections: this.sections });
    }
  }

  connectedDropLists(currentIndex:number):string[]{
    return this.sections.map((_,index)=> `dropListField-${index}`).filter((_,index) =>  index !== currentIndex)
  }

  async getContent(){

    try{
      this.commentService.progressSpin.emit(true)
      this.settingService.observeContextsWorkTasksTemplatesFirestore(this.idToShow).then( val => {
        this.taskTemplate = val
        this.convertDisplayFields()
        this.oldData = deepCopy(this.taskTemplate)
        this.initializeForm()
        this.commentService.progressSpin.emit(false)
      })

    }catch(error){
      this.commentService.progressSpin.emit(false)
    }
  }

  convertDisplayFields(){
    this.taskTemplate?.formSections?.forEach(section => {
      section.fields?.forEach(field => {
        if(field.type == "display"){
          field.type = "text"
          field.readOnly = true
        }
      })
    })
  }

  getTasksTemplatesGroups(){
    try{
      this.commentService.progressSpin.emit(true)
      this.taskTemplateGroupsSubscription?.unsubscribe()
      this.taskTemplateGroupsSubscription = this.settingService.observeContextsWorkTasksTemplatesGroupsFirestoreWithId().pipe(takeUntil(this.destroy$)).subscribe( val => {
        this.taskTemplateGroups = val
        this.sanitizeSelectedTaskTemplateGroup()
        if(this.taskTemplateGroups.length==0){
          this.emptyList=true
        }
        this.commentService.progressSpin.emit(false)
      })      

    }catch(error){
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  initializeForm(){
    const { actions,
            groupTitle,
            contentType,
            formSections,
            id,
            sortIndex,
            titleKeys,
            title,
            tridySource,
            visibleInPass,
            predicates,
            incomingTridys,
            outgoingTridys,taskType,
            groupId,
            userGroupIds,
            showImages,
            showComment,
            hidden,
            gpsMandatory,
          } = this.taskTemplate

    // Find the groups with the matching ID
    const matchingGroup = this.taskTemplateGroups?.find(group => group.id === groupId);
    this.taskTemplateGroupName = matchingGroup ? matchingGroup.title : undefined;

    this.taskTemplateForm.patchValue({
      groupTitle: groupTitle ? groupTitle : undefined,
      actions: actions ? actions : undefined,
      contentType: contentType ? contentType : undefined,
      formSections: formSections ? formSections : undefined,
      id: id ? id : undefined,
      sortIndex: sortIndex ? sortIndex : undefined,
      title: title ? title : undefined,
      tridySource: tridySource ? tridySource : undefined,
      visibleInPass: visibleInPass ? visibleInPass : false,
      predicates: predicates ? predicates : undefined,
      titleKeys: titleKeys ? titleKeys : undefined,
      incomingTridys : incomingTridys ? incomingTridys : undefined,
      outgoingTridys: outgoingTridys ? outgoingTridys :undefined,
      taskType: taskType ? taskType : undefined,
      groupId: groupId ? groupId : undefined,
      userGroupIds: userGroupIds ? userGroupIds : undefined,
      showImages:showImages, //? showImages : undefined,
      showComment:showComment, //? showComment : undefined,
      hidden: hidden ? hidden : undefined,
      gpsMandatory: gpsMandatory ? gpsMandatory : undefined,

    })
    this.selectedContentType = contentType

    if(!contentType)
    this.missingContentType = true

    this.taskTemplateForm.valueChanges.subscribe( (value:any)=>{
      this.changesToSave=true
    })


    if(this.taskTemplateForm.value.title){
      this.titleTask = this.taskTemplateForm.value.title
    }

    if(this.taskTemplateForm.value.formSections){
      this.sections = deepCopy(this.taskTemplateForm.value.formSections)
      this.checkDuplicatesKeys()
    }

    this.sanitizeSelectedTaskTemplateGroup()
  }

  private sanitizeSelectedTaskTemplateGroup(){
    const groupId = this.taskTemplateForm?.value?.groupId
    if(groupId && Array.isArray(this.taskTemplateGroups) && !this.taskTemplateGroups.some(group => group.id === groupId)){
      this.taskTemplateForm.patchValue({groupId: undefined})
      this.taskTemplateGroupName = undefined
    }
  }

  backTo(){
    this.router.navigate(['home', this.settingService.contextId$,'taskTemplates'])
  }

  saveTaskTemplate(){
    if(this.tasktemplateUserRights_update){
      if(!this.duplicateKeys){
        try{
          this.commentService.progressSpin.emit(true)
          const data:any = removeUndefinedValuesFromObject(this.taskTemplateForm.value)
          const fieldsToUpdate = ['groupId', 'userGroupIds', 'titleKeys', 'predicates', 'actions', 'incomingTridys','outgoingTridys']
          let clean = deepCopy(data)
          fieldsToUpdate.forEach(field => {
            if ((this.oldData[field] && !data[field]) || (data[field] && data[field]?.length==0)) {
              data[field] = deleteField()
              delete clean[field]
            }
          })

          this.worktasktemplateService.updateWorkTaskTemplate(data, this.idToShow).then(() => {
            this.commentService.progressSpin.emit(false)
            this.titleTask = data.title
            this.oldData = deepCopy(clean)
            this.taskTemplate = deepCopy(clean)
            this.initializeForm()
            this.changesToSave = false
            const message = this.translate.instant("SnackBarConstants.UPDATE_OK")
            this.commentService.addSnackBar.emit(message)
          }).catch(error => {
            console.log(error)
            this.commentService.progressSpin.emit(false)
            const message = this.translate.instant("SnackBarConstants.UPDATE_FAILED")
            this.commentService.addSnackBar.emit(message)
          })
        }catch(error){
          console.log(error)
          this.commentService.progressSpin.emit(false)
          const message = this.translate.instant("SnackBarConstants.UPDATE_FAILED")
          this.commentService.addSnackBar.emit(message)
        }
      }else{
        let dialogRef= this.dialog.open(ErrorDialogComponent, {
          data: {
            message: 'taskTemplates.unique_keys'
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result[1]){

          }
        });
      }
    }else{
      const message = this.translate.instant("SnackBarConstants.NOT_ALLOWED_UPDATE")
      this.commentService.addSnackBar.emit(message)
    }

  }

  addSection(){
    const defaultTitle = this.translate.instant("workTask.newSection");
    const newSection = deepCopy(newSectionWorkTaskTemplate)
    newSection.title = defaultTitle
    newSection.fields = deepCopy(newSection.fields || [])
    newSection.id = newSection.id || makeid(6)

    this.sections.push(newSection)
    this.taskTemplateForm.patchValue({formSections: this.sections})
  }

  deleteSection(title, index){
    this.sections.splice(index,1)
    this.taskTemplateForm.patchValue({formSections: this.sections})
  }

  duplicateSection(section, index){
    const newSection = deepCopy(section)

    if(newSection.fields){
      newSection.fields.forEach((field, index) => {
        field.id = makeid(6)
        this.allIds = field.id
        field.key += '_copy'
        this.allKeys.push(field.key)
      });
    }
    newSection.title += '_copy'
    this.sections.push(newSection)
    this.taskTemplateForm.patchValue({formSections: this.sections})

  }

  ngOnDestroy(): void {
    this.taskTemplateGroupsSubscription?.unsubscribe()
    this.destroy$.next();
    this.destroy$.complete();
  }

  makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }

    if(this.allIds.includes(result)){
      result = makeid(6)
    }
    return result;
}

  addFieldToSection(fieldType, section){
    const id= makeid(6)
    const _defaultFields = defaultFields
    if(!this.allIds.includes(id)){
      this.allIds.push(id)
    }
    const newField = deepCopy(_defaultFields[fieldType])
    newField['id']=id

    if (!this.addedFieldsByType[fieldType]) {
      this.addedFieldsByType[fieldType] = 0
    }
    this.addedFieldsByType[fieldType]++

    const fieldTitle = this.fieldTypeTitles[fieldType] || 'New Field';
    newField['title'] = `${fieldTitle} ${this.addedFieldsByType[fieldType]}`;
    newField['key']+=''+this.addedFieldsByType[fieldType]

    if(fieldType=='tridy'){
      if (this.taskTemplateForm.value.contentType){
        newField['contentType'] = this.taskTemplateForm.value.contentType
      }
    }
    if(this.allKeys.includes(newField['key'])){
      const random = makeid(4)
      newField['key']+=''+ random
    }
    if(this.sections && this.sections[section] && this.sections[section].fields){
      this.sections[section].fields.push(newField)
      this.allKeys.push(newField.key)
      this.taskTemplateForm.patchValue({formSections: this.sections})
    }
  }

  deleteFieldOfSection(fieldNumber, index){
    this.sections[index].fields.splice(fieldNumber,1)
    this.taskTemplateForm.patchValue({formSections: this.sections})
  }

  editTitleSection(title, index){
    let dialogRef= this.dialog.open(TaskTemplateEditSectionDialogComponent, {
      data: {
         values: title
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[1]){
        this.sections[index].title = result[0].title
        this.sections[index].titles = this.sections[index].titles || {}
        this.sections[index].titles['de'] = result[0].title
        this.taskTemplateForm.patchValue({formSections: this.sections})
      }
    });
  }

  openWorkTaskTemplateDialog(){
      let dialogRef = this.dialog.open(WorkTaskTemplateDialogComponent, {
      data: {
         values: this.taskTemplateForm.value,
         groups: this.taskTemplateGroups,
         userGroups: this.userGroupList
      },
      panelClass: 'custom-dialog-container',
      position: { right: '0'},
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '200ms'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[1]){
        this.taskTemplateForm.patchValue(result[0])

        if(result[0].groupId){
          const groupId = this.taskTemplateForm.value['groupId']
          const matchingGroup = this.taskTemplateGroups.find(group => group.id === groupId);
          this.taskTemplateGroupName = matchingGroup ? matchingGroup.title : undefined;
        }else{
          if(this.taskTemplateGroupName){
            this.taskTemplateGroupName=""
          }
        }


      }
    });
  }

  openWorkTaskTemplateAdvancedDialog(){
    let dialogRef = this.dialog.open(WorkTaskTemplateAdvancedDialogComponent, {
      data: {
         values: this.taskTemplateForm.value
      },
      panelClass: 'custom-dialog-container',
      position: { right: '0'},
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '200ms'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[1]){
        this.taskTemplateForm.patchValue(result[0])
      }
    });
  }

  openFieldDialog(item, fieldNumber,index){
    let dialogRef = this.dialog.open(TaskTemplateFieldDialogComponent, {
    data: {
       values: item,
       taskId: this.idToShow,
       fieldNumber:fieldNumber,
       sectionNumber: index
    },
    width: '600px',
    panelClass: 'custom-dialog-container',
      position: { right: '0'},
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '200ms'
  });

  dialogRef.afterClosed().subscribe(result => {

    if(result[1]){

      this.sections[index].fields[fieldNumber]=result[0]
      this.taskTemplateForm.patchValue({formSections: this.sections})

    }
  });
  }

  deleteTask(){
    let dialogRef= this.dialog.open(DeleteConfirmationDialogComponent, {
      data: {
        values:this.taskTemplateForm.value,
        type:"Task Template"
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        this.router.navigate(['home',this.settingService.contextId$,'taskTemplates'])
      }else{
        const message = this.translate.instant("SnackBarConstants.DELETE_DISMISS")
        this.commentService.addSnackBar.emit(message)
      }
    });
  }

  checkDuplicatesKeys(){
    let allFieldsNumber = 0
    this.allIds=[]
    this.allKeys=[]
    this.addedFieldsByType = {}
    let changes = false
    this.duplicateKeys = false

    this.sections.forEach((section, index) => {
      if(section.fields ){
        section.fields.forEach( (field, number) => {
          if(field.id){
            if(this.allIds.includes(field.id)){
              field.id = makeid(6)
              changes = true
              this.allIds.push(field.id)
            }else{
              this.allIds.push(field.id)
            }
          }

          if(field.key){
            if(field.key.includes(" ")){
              // field.key = field.key.replace(" ", "_")
              // field.key = field.key.replaceAll(" ", "_")
            }
            allFieldsNumber++
            this.addedFields = allFieldsNumber

            if(field.type){
              if(!this.addedFieldsByType[field.type]){
                this.addedFieldsByType[field.type] = 0
              }
              this.addedFieldsByType[field.type]++
            }

            if(this.allKeys.includes(field.key)){
              this.duplicateKeys = true
              this.allKeys.push(field.key)
            }else{
              this.allKeys.push(field.key)
            }
          }else{
            if(field.key==""){
              if(this.allKeys.includes(field.key)){
                this.duplicateKeys = true
                this.allKeys.push("")
              }else{
                this.allKeys.push("")
              }
            }
          }

          if(field.payloadKey){
            if(field.payloadKey.includes(" ")){
              // field.payloadKey = field.payloadKey.replace(" ", "_")
              // field.payloadKey = field.payloadKey.replaceAll(" ", "_")
            }
          }

          if(this.selectedContentType && field.type=='tridy'){///---this prevents tridy fields without contentType
            if(!field.contentType){
              field.contentType = this.selectedContentType
              this.taskTemplateForm.patchValue({formSections : this.sections})
            }
          }
        })
      }
    });

    if(changes){
      this.taskTemplateForm.patchValue({formSections : this.sections})
    }
  }

  isTime(value){
    return isTime(value)
  }
  getContentTypeIdName(id){
    const content = this.allContentTypesList?.find( contentType => contentType.id == id )
    if(content)
    return content.displayName
  }

  includesSource(source, value){
    if(source && source.includes(value))
    return true
    else
    return false
  }

  transformMarkDownText(item){
    let texttransformed
    if(item.value){
      let markdown = new MarkdownIt({ breaks: true });

      const defaultRender = markdown.renderer.rules.link_open ||
        ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

      markdown.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        if (token.attrIndex('href') >= 0) {
          token.attrSet('target', '_blank');
          token.attrSet('rel', 'noopener noreferrer');
        }
        return defaultRender(tokens, idx, options, env, self);
      };



      let text = markdown.render(item.value);
      texttransformed = text;
    }
    return texttransformed
  }

  loadShowImage(defaultValue){
    let url = supportUrlStructure(defaultValue, this.idToShow, this.settingService.contextId$)
    return url
  }

  getUserGroups(){
    try{
      this.commentService.progressSpin.emit(true)
      this.usGroupsService.observeContextsUserGroupsFirestoreWithId().subscribe( value => {
        this.userGroupList = value ?? []
        this.commentService.progressSpin.emit(false)
      })

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }
}
